import {Component, Inject} from '@angular/core';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: 'password-generated-component',
  templateUrl: 'password.generated.html',
  styleUrls: ['./password.generated.css'],
})

export class PasswordGeneratedComponent {
  password: string;

  constructor(
    public dialogRef: MatDialogRef<PasswordGeneratedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.password = data;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
